import React from 'react'
import Appstore from './Appstore'
import More from './More'
import Playstore from './Playstore'

const PopUpContent = ({ name, information }) => {
    return (
        <div className='mt-4 flex flex-col'>
            <div className={`service-icon ${information.attributes[0].cssClass} w-6 h-6 absolute right-[13px]`}></div>
            <div className='flex flex-col gap-0 text-2xl w-[95%] mb-6'>
                <h3 className='text-2xl w-[95%] leading-[1.2em] mb-0 pb-0'>{name}</h3>
                <span className="text-[#7b7b7b] text-[16px] leading-[1.2em]">{information.address}</span>
            </div>
            <div className="textcontent" dangerouslySetInnerHTML={{ __html: information.provider.description }}>
                {/* bad bad innerHTML */}
            </div>
            <div className='mb-6'>
                {/* (information.totalSlots >= 1) && <p>Freie Boxen: {information.vacantSlots}/{information.totalSlots}</p> */}
                { (information.totalSlots >= 1) && <p>Anzahl Boxen: {information.totalSlots}</p> }
            </div>
            <div className={`${(information.provider.urlApple !== '' || (information.provider.urlGoogle !== '')) ? 'flex mt-8 mb-4 w-full justify-between' : 'hidden'}`}>
                { (information.provider.urlApple !== '') && <Appstore {...{information}} /> }
                { (information.provider.urlGoogle !== '') && <Playstore {...{information}} /> }
            </div>
            <div>
                { (information.provider.urlWebsite !== '') && <More {...{information}} /> }
            </div>
        </div>
    )
}

export default PopUpContent
